import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentListItemAdditionFailedAction = {
	type: 'DOCUMENT_LIST_ITEM_ADDITION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentListItemAdditionFailedAction => ({
	type: 'DOCUMENT_LIST_ITEM_ADDITION_FAILED',
	payload,
});
